import { useQuery } from "@tanstack/react-query";
import { getConfig } from "core/utilities";
import firebase from "firebase/compat/app";
import { StockByType } from "resbutler-utils/types";
import { buildDataFromCollection } from "resbutler-utils/utils";

export const refreshStockData = (queryClient, clientId, date, restaurantId) => {
  queryClient.invalidateQueries(["stocks", clientId, date, restaurantId]);
};

export function useStocks(date: number, restaurantId: string): { loading: boolean; data: StockByType } {
  const { client: clientId } = getConfig();

  const { isLoading, data = { products: {}, specials: {} } } = useQuery<StockByType>({
    queryKey: ["stocks", clientId, date, restaurantId],
    enabled: !!clientId && !!date && !!restaurantId,
    queryFn: async () => {
      const [snapProducts, snapSpecials] = await Promise.all([
        firebase.firestore().collection(`${clientId}/stocks/date/${date}/restaurants/${restaurantId}/products`).get(), //
        firebase.firestore().collection(`${clientId}/stocks/date/${date}/restaurants/${restaurantId}/specials`).get(),
      ]);
      const productsStocks = snapProducts.empty ? {} : buildDataFromCollection(snapProducts);
      const specialStocks = snapSpecials.empty ? {} : buildDataFromCollection(snapSpecials);
      return { products: productsStocks, specials: specialStocks } as StockByType;
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 120 * 60 * 1000,
  });

  return {
    loading: isLoading,
    data: data,
  };
}
